import {
  Contacts as ContactsIcon,
  Security,
  SupervisedUserCircle,
} from "@material-ui/icons"
import Dashboard from "@material-ui/icons/Dashboard"
import Home from "@material-ui/icons/AddAlert"
import ListAlt from "@material-ui/icons/ListAlt"
import EmojiPeopleIcon from "@material-ui/icons/EmojiPeople"
import LibraryBooksIcon from "@material-ui/icons/LibraryBooks"
import SupervisorAccountIcon from "@material-ui/icons/SupervisorAccount"
import LowPriorityIcon from "@material-ui/icons/LowPriority"
import MenuBookIcon from "@material-ui/icons/MenuBook"

export const getSupervisorSections = () => [
  {
    id: "supervisor",
    items: [
      {
        id: "registro_entradas",
        title: "Registro de Entradas",
        icon: Dashboard,
        href: "/guardia/dashboard",
      },
      {
        id: "alerta",
        title: "Alerta",
        icon: Home,
        href: "/guardia/alerta",
      },
      {
        id: "bitacora",
        title: "Bitácora Digital",
        icon: ListAlt,
        href: "/guardia/bitacoraDigital",
      },
      {
        id: "novedades",
        title: "Novedades",
        icon: MenuBookIcon,
        href: "/guardia/eventos",
      },
      {
        id: "bitacoras_rechazadas",
        title: "Bitácoras Rechazadas",
        icon: LowPriorityIcon,
        href: "/guardia/bitacoraRechazada",
      },
      {
        id: "visitas_anticipadas",
        title: "Visitas anticipadas",
        icon: EmojiPeopleIcon,
        href: "/guardia/visitasAnticipadas",
      },
      {
        id: "listas",
        title: "Listas B/N",
        icon: ContactsIcon,
        href: "/guardia/listas",
      },
      {
        id: "historial",
        title: "Historial",
        icon: LibraryBooksIcon,
        items: [
          {
            id: "historial_cambios",
            title: "Cambios de Guardias",
            href: "/guardia/ingresos",
          },
          {
            id: "historial_rondas",
            title: "Rondas",
            href: "/guardia/rondas",
          },
          {
            id: "historial_reservas",
            title: "Reservas",
            href: "/guardia/reservas",
          },
        ],
      },
      {
        id: "familia",
        title: "Familia/Inquilinos",
        icon: SupervisorAccountIcon,
        href: "/guardia/familia",
      },
      {
        id: "aprobadores",
        title: "Lista de Aprobadores",
        icon: Security,
        href: "/guardia/aprobadores",
      },
      {
        id: "gestionarGuardias",
        title: "Guardias",
        icon: SupervisedUserCircle,
        href: "/guardia/gestionarGuardias",
      },
    ],
  },
]
